import { resolveOrganisationDisplayName } from "../../utils/string";
export const decodeNotification = async (notification, getImageUrl) => {
    const organisationLogo = notification.organisation_logo && notification.organisation_logo.length > 0
        ? await getImageUrl(notification.organisation_logo)
        : "";
    return {
        contractorPackageId: notification.contractor_package_id,
        created: new Date(notification.created),
        deleted: notification.deleted,
        id: notification.notification_id,
        organisationDisplayName: resolveOrganisationDisplayName(notification.organisation_name || "", notification.canonical_name),
        organisationId: notification.organisation_id,
        organisationLogo: organisationLogo,
        organisationName: notification.organisation_name || "",
        projectId: notification.project_id,
        projectName: notification.project_name || "",
        reportId: notification.report_id,
        type: notification.type,
        userViewed: notification.user_viewed ?? false,
        viewedAt: notification.viewed_at
            ? new Date(notification.viewed_at)
            : new Date()
    };
};
export const encodeNotification = (notification) => {
    return {
        contractor_package_id: notification.contractorPackageId,
        created: notification.created,
        deleted: notification.deleted,
        notification_id: notification.id,
        organisation_id: notification.organisationId,
        project_id: notification.projectId,
        report_id: notification.reportId,
        type: notification.type
    };
};
